import React from 'react'
import { useNavigate, useLocation } from '@/lib/router-dom';
import classNames from 'classnames';
import PropTypes from "prop-types";

export const NavigationSubLink = ({to, icon, text, disabled, hidden}) => {
	const { goTo } = useNavigate();
	const { currentPath } = useLocation();

	const onClick = (e) => {
		e.preventDefault();
		if (!disabled) {
			goTo(to);
		}
	}

	const isActive = currentPath?.startsWith(to);

	const navigationClass = classNames({
		'navigation-sub-item': true,
		'navigation-sub-item--active': isActive,
		'navigation-sub-item--disabled': disabled
	})

	if (hidden) return null;

	return (
		<a href={to} onClick={onClick} className={navigationClass} id={`navigation-sub-dashboard-tab-${text?.toLowerCase()?.replaceAll(/\s+/g, '-')}`}>
			<div className="navigation-sub-item__side__rectangle"></div>
			<div className="navigation-sub-item__icon">{icon}</div>
			<div className="navigation-sub-item__label" id={`navigation-sub-dashboard-tab-${text?.toLowerCase()?.replaceAll(/\s+/g, '-')}`}>{text}</div>
		</a>
	)
}

NavigationSubLink.propTypes = {
	to: PropTypes.string.isRequired,
	icon: PropTypes.node.isRequired,
	text: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	hidden: PropTypes.bool
}
